import { combineReducers } from 'redux';
import { DeezerLibraryReducer } from '../library/DeezerLibraryReducer';
import { DeezerUserArtistsReducer } from '../userArtists/DeezerUserArtistsReducer';

export const DeezerReducer = combineReducers({
  library: DeezerLibraryReducer,
  userArtists: DeezerUserArtistsReducer,
});
